function IconRoleJournalist({ ...rest }) {
  return (
    <>
      <svg viewBox="0 0 48 48" fill="currentColor" {...rest}>
        <path
          id="path7"
          d="M17.9,29.7c-0.1-0.2-0.3-0.3-0.5-0.3H15c-4.3,0-7.8,3.5-7.8,7.8v3.5c0,0.6,0.5,1.2,1.2,1.2h12.9 c0.3,0,0.6-0.3,0.5-0.7L17.9,29.7z M34.1,29.3h-2.4c-0.2,0-0.4,0.1-0.5,0.3l-3.7,11.5c-0.1,0.3,0.1,0.7,0.5,0.7h12.8 c0.6,0,1.2-0.5,1.2-1.2v-3.5C41.9,32.8,38.4,29.3,34.1,29.3z M34.1,16.8c0-5.3-4.3-9.6-9.6-9.6s-9.6,4.3-9.6,9.6 c0,5.3,4.3,9.6,9.6,9.6S34.1,22.1,34.1,16.8z"
        />
        <path
          id="path9"
          d="M24.5,29.6c-0.8,0-1.5,0.7-1.5,1.5v8c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5v-8 C26,30.3,25.3,29.6,24.5,29.6z"
        />
      </svg>
    </>
  );
}

export default IconRoleJournalist;
